import React from 'react'
import BloomSpinner from '../../../assets/img/bloom_spinner_grey.gif';

const smallSpinnerStyle = {
  display: 'flex',
  justifyContent: 'center'
}

const bigSpinnerStyle = {
  minHeight: 'calc(100vh - 300px)',
  display: 'flex',
  justifyContent: 'center'
}

const Spinner = ({ size }) => <div
  className='sweet-loading'
  style={size === 'small' ? smallSpinnerStyle : bigSpinnerStyle}>
  <div style={{ margin: 'auto' }}>
    <img style={{width: 100, height: 100}} src={BloomSpinner} alt="Loading logo"/>
  </div>
</div>

export const SmallSpinner = () => <Spinner size='small' />

export const BigSpinner = () => <Spinner />
